<template>
  <b-card>
    <!-- for loading page -->
    <app-loading :className="isLoading ? 'loading' : ''"></app-loading>
    <div class="col-sm-12">
      <h4 class="h4-title">{{pageTitle}}</h4>
      <b-row>
        <b-col sm="12">
          <b-form-file
            v-model="file"
            :state="Boolean(file)"
            placeholder="Choose a file or drop it here..."
            drop-placeholder="Drop file here..."
            accept=".xlsx"
          ></b-form-file>
          <button
            type="button"
            class="btn action-b-btn b-btn"
            @click="importResidents"
            :disabled="isLoading"
          >
            <b-spinner
              small
              v-if="isLoading"
            ></b-spinner>
            {{saveBtnCaption}}
          </button>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-progress
            v-if="value>0"
            :max="max"
            height="2rem"
          >
            <b-progress-bar
              :value="value"
              variant="success"
            >
              <span v-if="value<max"><strong>Uploading: {{ value }} / {{ max }}</strong></span>
              <span v-if="value==max"><strong>Upload Completed ({{ value }} / {{ max }})</strong></span>
            </b-progress-bar>
          </b-progress>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="12">
          <b-alert
            show
            variant="warning"
          >
            <strong>Below shows the sample for Excel (.xlsx) format. Please follow this format. <br />
              PLEASE NOTE: Column names are case-sensitive.<br />
              <p>
                Project Code Legends:
                <ul>
                  <li>
                    WC = Whizdom Connect
                  </li>
                  <li>
                    WE = Whizdom Essence
                  </li>
                  <li>
                    MBSC = Mulberry Grove
                  </li>
                  <li>
                    W2 = Whizdom Punnawithi
                  </li>
                </ul>
              </p>
            </strong>
          </b-alert>
          <strong><a
              href="/images/residents/residents_template.xlsx"
              download
            >Download Template</a></strong>
          <b-img
            center
            fluid-grow
            src="/images/residents/sampleexcel.png"
            alt="Excel Sample"
          ></b-img>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>
<script>
import XLSX from 'xlsx';
import MqdcOneClient from '@/models/mqdc-one-client';
import Loading from '@/components/Loading';

export default {
  name: 'Excel',
  data () {
    return {
      pageTitle: 'Import residents via Excel',
      saveBtnCaption: 'Upload',
      noFileError: 'Please select file to upload',
      formatError: 'Error! Mobile number and Id card are required.',
      max: 0,
      value: 0,
      file: null,
      mqdcOneClient: {},
      isLoading: false
    };
  },
  mounted () {
    this.mqdcOneClient = new MqdcOneClient(this.axios);
  },
  watch: {
    value: function (newValue, oldValue) {
      if (newValue === this.max) {
        this.isLoading = false;
      }
    }
  },
  methods: {
    importResidents () {
      if (null === this.file) {
        this.$alert(this.noFileError, 'Error', 'error').then(() => { });
        return;
      }
      this.resultUnique = [];
      this.isLoading = true;
      this.fileToJson(this.file, (data) => {
        this.max = data.length;
        let helper = {};
        try {
          data.forEach((item) => {
            if (!('mobile' in item) || !('idCard' in item)) {
              this.isLoading = false;
              throw this.formatError;
            }
          });

          let uniqueData = data.reduce(function (r, o) {
            let key = o.mobile + '-' + o.idCard;
            if (!helper[key]) {
              helper[key] = Object.assign({}, o); // create a copy of o
              r.push(helper[key]);
            }

            return r;
          }, []);

          let residentsArray = [];
          uniqueData.forEach(element => {
            let mobile = 'number' === typeof element.mobile ? element.mobile.toString() : element.mobile;
            let idCard = 'number' === typeof element.idCard ? element.idCard.toString() : element.idCard;
            residentsArray.push({
              'firstName': element.firstName,
              'lastName': element.lastName,
              'middleName': element.middleName,
              'email': element.email,
              'mobile': mobile,
              'idCard': idCard
            });
          });

          this.sendData(residentsArray, data);
        } catch (e) {
          console.error(e);
          this.$alert(e, 'Error', 'error').then(() => { });
        }
      }); // json
    },
    fileToJson (file, cb) {
      /* Boilerplate to set up FileReader */
      const reader = new FileReader();
      reader.onload = (e) => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_json(ws, { skipHeader: true });
        /* Update state */
        cb(data);
      };
      reader.readAsBinaryString(file);
    },
    sendData (residents, allData) {
      this.mqdcOneClient.getAxios().then(axios => {
        let postResidents = [];
        residents.forEach(element => {
          const residentProfile = {
            'firstName': element.firstName,
            'lastName': element.lastName,
            'middleName': element.middleName,
            'email': element.email,
            'mobile': element.mobile,
            'idCard': element.idCard
          };

          const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/residents`;
          postResidents.push(axios.post(url, residentProfile));
        });
        Promise
          .all(postResidents)
          .then((responses) => {
            responses.forEach(res => {
              this.postProjects(res.data.data, allData, axios);
            });
          })
          .catch(error => { console.log(error); });
      });
    },
    postProjects (element, allData, axios) {
      const postProjects = [];
      const projectCodes = allData.filter(({ mobile, idCard }) => {
        return mobile.toString() === element.mobile.toString() && idCard.toString() === element.idCard.toString();
      });

      const uniqueProjectCodes = projectCodes.filter((set => f => !set.has(f.projectCode) && set.add(f.projectCode))(new Set()));

      const url = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/residents/${element.id}/projects`;

      uniqueProjectCodes.forEach(item => {
        const project = { 'projectCode': item.projectCode };
        postProjects.push(axios.post(
          url, project));
      });
      Promise
        .all(postProjects)
        .then((responses) => {
          if (responses.length > 0) {
            this.postUnits(element, projectCodes, axios);
          }
        })
        .catch(error => { console.log(error); });
    },
    postUnits (residentElement, filterData, axios) {
      const postUnits = [];
      filterData.forEach(item => {
        let unit = {
          'unitNumber': item.unitNumber
        };
        const urlUnit = `${process.env.VUE_APP_URL_MQDCONE_API}/mqdc-one/residents/${residentElement.id}/projects/${item.projectCode}/units`;
        postUnits.push(axios.post(
          urlUnit, unit));
      });
      Promise
        .all(postUnits)
        .then((responses) => {
          responses.forEach(res => {
            this.value++;
          });
        });
    }
  },
  components: {
    'app-loading': Loading
  }
};
</script>
<style scoped src="@/assets/css/resident.css"></style>
